import { Instance, SnapshotIn, types } from 'mobx-state-tree';

export interface WebProps {
  id: number;
  origin: string;
  comment: string;
}

export const Web = types.model({
  id: types.number,
  origin: types.string,
  comment: types.string,
});

export type WebSnapshot = SnapshotIn<typeof Web>;
export type WebInstance = Instance<typeof Web>;
